(() => {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const players = new Set();
  const init = (scope = document) => scope.querySelectorAll('[data-sw-film]').forEach(figure => {
    if (figure.dataset.initialized) return;
    figure.dataset.initialized = 'true';
    const video = figure.querySelector('video');
    const poster = figure.querySelector('.sw-film__poster');
    const caption = figure.querySelector('[data-sw-film-caption]');
    const error = figure.querySelector('[data-sw-film-error]');
    let visible = false, version = 0, pending = false, explicitMotion = false;
    video.loop = true;
    video.muted = true;
    video.playsInline = true;
    const source = () => figure.dataset[figure.dataset.finish === 'black' ? 'blackSrc' : 'whiteSrc'];
    const stop = () => video.pause();
    const play = async () => {
      if (!source() || pending || !video.paused) return;
      const requestVersion = version;
      if (video.getAttribute('src') !== source()) video.src = source();
      error.hidden = true;
      pending = true;
      try { await video.play(); }
      catch (failure) {
        if (requestVersion !== version || failure.name === 'AbortError') return;
        if (failure.name !== 'NotAllowedError') error.hidden = false;
      } finally { if (requestVersion === version) pending = false; }
    };
    const sync = () => {
      if (!visible || document.hidden || (reduced.matches && !explicitMotion)) { stop(); return; }
      play();
    };
    const updateFinish = finish => {
      if (figure.dataset.finish === finish) return;
      version++; pending = false;
      stop();
      figure.dataset.finish = finish;
      figure.dataset.started = 'false';
      video.removeAttribute('src');
      video.load();
      const newPoster = figure.dataset[finish === 'black' ? 'blackPoster' : 'whitePoster'];
      video.poster = newPoster;
      poster.src = newPoster;
      poster.alt = `${finish === 'black' ? 'Black' : 'White'} electric burr coffee grinder, shown in a styled product visualization`;
      video.setAttribute('aria-label', `Looping ${finish} grinder studio film`);
      caption.textContent = `${finish === 'black' ? 'Black' : 'White'} finish · Product visualization`;
      error.hidden = true;
      sync();
    };
    video.addEventListener('playing', () => { figure.dataset.started = 'true'; });
    video.addEventListener('error', () => { figure.dataset.started = 'false'; error.hidden = false; });
    let observer;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, {threshold:0});
      observer.observe(figure);
    } else { visible = true; sync(); }
    const product = figure.closest('[data-sw-product]');
    const variantChanged = event => updateFinish(/^black/i.test(event.detail.title) ? 'black' : 'white');
    product?.addEventListener('sw:variant-change', variantChanged);
    figure.addEventListener('sw:play-film', () => { explicitMotion = true; visible = true; sync(); });
    players.add({figure, sync, stop, resetMotion:() => { explicitMotion = false; sync(); }, destroy:() => { stop(); observer?.disconnect(); product?.removeEventListener('sw:variant-change',variantChanged); }});
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-sw-watch-film]');
    if (!link) return;
    const section = document.getElementById('sw-grinder-film');
    const film = section?.querySelector('[data-sw-film]');
    if (!film) return;
    event.preventDefault();
    section.scrollIntoView({behavior:reduced.matches ? 'instant' : 'smooth',block:'start'});
    film.dispatchEvent(new CustomEvent('sw:play-film'));
  });
  document.addEventListener('visibilitychange', () => players.forEach(player => player.sync()));
  reduced.addEventListener('change', () => players.forEach(player => player.resetMotion()));
  window.addEventListener('pageshow', () => players.forEach(player => player.sync()));
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => players.forEach(player => { if (event.target.contains(player.figure)) { player.destroy(); players.delete(player); } }));
  init();
})();
